import { bookingJourneyType } from 'common/constants/booking';

export const getStudentName = (record, bookingJourney) => {
  if (bookingJourney !== bookingJourneyType.MANUAL) {
    return record?.passportFullName;
  }

  const { passportFirstName, passportMiddleName, passportLastName } = record?.student ?? {};
  let studentName = '-';

  if (passportFirstName) {
    studentName = passportFirstName;
  }

  if (passportMiddleName) {
    studentName =
      studentName === '-' ? passportMiddleName : studentName.concat(' ', passportMiddleName);
  }
  if (passportLastName) {
    studentName =
      studentName === '-' ? passportLastName : studentName.concat(' ', passportLastName);
  }

  return studentName;
};
